/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { Container, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Typography } from "@mui/material";
import styles from "./SidePanel.module.css";
import { Category, Dashboard, Logout, Person, Settings } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { logout } from "../../Store/Slices/authSlice";
import { Link, useLocation } from "react-router-dom";

const SidePanel = () => {
  const dispatch = useDispatch();

  const onLogout = () => {
    dispatch(logout());
    window.location.reload();
  };
  const location = useLocation();

  const roles = sessionStorage.getItem("roles");

    const list = [
        {name: 'User Management', link: '/admin/user' , validation:roles?.split(",").includes("PRIV_ES_DISPLAYUSER")},
        {name: 'BR Management', link: '/admin/br', validation:roles?.split(",").includes("PRIV_ES_DISPLAY_ROLES")},
        {name: 'Privilege Management', link: '/admin/privilege' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_PRIVILEGES")},
        {name: 'Br Privilege Mapping', link: '/admin/br-priv-mapping' , validation:roles?.split(",").includes("PRIV_ES_DISPLAY_MAPPINGS")},
        {name: 'Resource Management', link: '/admin/resource' , validation: roles?.split(",").includes("PRIV_ES_DISPLAY_RESOURCE")},
        {name: 'State Management', link: '/admin/state' , validation:roles?.split(",").includes("PRIV_ES_DISPLAY_STATES")},
        {name: 'Area Management', link: '/admin/area' , validation: roles?.split(",").includes("PRIV_ES_DISPLAY_AREAS")},
        {name: 'Category Management', link: '/admin/category' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_CATEGORIES")},
        {name: 'Calendar Management', link: '/admin/calendar', validation : roles?.split(",").includes("PRIV_ES_DISPLAY_CALENDAR")},
        {name: 'Slot Management', link: '/admin/slot' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_SLOTS")},
        {name: 'Coupon Management', link: '/admin/coupon' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_COUPONS")},
        {name: 'Charges Management', link: '/admin/charges' , validation: roles?.split(",").includes("PRIV_ES_DISPLAY_CHARGES")},
        {name: 'Frequency Management', link: '/admin/frequency' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_FREQUENCIES")},
        {name: 'No of Hours Management', link: '/admin/no-of-hrs' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_NO_HRS")},
        {name: 'No of Resources Management', link: '/admin/no-of-res' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_NO_RES")},
        {name: 'Offer Management', link: '/admin/offer',validation : roles?.split(",").includes("PRIV_ES_DISPLAY_OFFERS")},
        {name: 'Price Table Management', link: '/admin/price-table' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_PRICE_TBL") },
        {name: 'Request Management', link: '/admin/request' ,validation : roles?.split(",").includes("PRIV_ES_DISPLAY_REQUESTS")},
        {name: 'Review Management', link: '/admin/comments' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_COMMENTS")},
        {name: 'Notification Management', link: '/admin/notification' , validation : roles?.split(",").includes("PRIV_ES_DISPLAY_NOTIFICATIONS")},
    ]

    return (
        <Paper className={styles.container} elevation={3} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Dashboard.png)`}}>
            <Typography className={styles.title}>Admin Dashboard</Typography>
            <div>
                <MenuList className={styles.listContainer}>
                    {list.map(item => (
                        item.validation  ?   <Link key={item.link} className={styles.link} to={item.link}>
                            <MenuItem className={location.pathname === item.link ? styles.selected : styles.listItem}>
                                <ListItemText>{item.name}</ListItemText>
                            </MenuItem>
                        </Link>  : null
                    ))}
                </MenuList>
            </div>
        </Paper>
    );
}

export default SidePanel